"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const commonDefinitions = {
    '#': /\d/,
};
const applyMask = (input, mask, { typeahead = false, definitions = {}, } = {}) => {
    let maskedValue = '';
    let unmaskedValue = '';
    let inputIndex = 0;
    let maskIndex = 0;
    let handledMaskCharsCount = 0;
    const allDefinitions = { ...commonDefinitions, ...definitions };
    while (inputIndex < input.length && maskIndex < mask.length) {
        const inputSymbol = input[inputIndex];
        const maskSymbol = mask[maskIndex];
        const regex = allDefinitions[maskSymbol];
        const nextRegexp = typeof regex === 'function' ? regex(input) : regex;
        if (!regex) {
            maskedValue += maskSymbol;
            handledMaskCharsCount += 1;
            maskIndex += 1;
        }
        else if (!nextRegexp.test(inputSymbol)) {
            inputIndex += 1;
        }
        else {
            maskIndex += 1;
            inputIndex += 1;
            handledMaskCharsCount += 1;
            maskedValue += inputSymbol;
            unmaskedValue += inputSymbol;
        }
        // do not continue adding mask symbols, typeahead below
        if (maskedValue === input) {
            break;
        }
    }
    // adds mask symbols at the end of input
    if (typeahead) {
        while (mask[maskIndex]) {
            if (!allDefinitions[mask[maskIndex]]) {
                maskedValue += mask[maskIndex];
            }
            else {
                break;
            }
            maskIndex += 1;
        }
    }
    return {
        maskedValue,
        unmaskedValue,
        complete: handledMaskCharsCount === mask.length,
    };
};
exports.default = applyMask;
